import { ProductSortDirectionEnum } from "common/enums";

export const sortDirectionVal: string[] = [
  ProductSortDirectionEnum.Ascending,
  ProductSortDirectionEnum.Descending,
];
